import React, { useState, useEffect } from 'react';
// components
import Table from '../../components/Table';
import { useTranslation } from 'react-i18next';
import { Loading } from 'react-loading-ui';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useSelector } from 'react-redux';
import { getAlertLive, getEquipmentRoomLive, getUserRequestAPI } from '../../API/RDPMS_API';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'material-design-icons/iconfont/material-icons.css';
import '../../../src/assets/scss/custom/components/_alert.scss';
import '../dashboard/Dashboard/Dashboard.css';
import MultiSelectDropdown from '../../components/MultiSelectDropdown';
import {
    equipmentRoomLiveColumns,
    mapRequestDataToOptions,
    rdpmshealthDetailsColumns,
    rdpmshealthLiveColumns,
    sizePerPageList,
} from './requestDataMapper';
import PieChartComponent from '../../components/Charts/PieChartComponent';
import BarChartComponent from '../../components/Charts/BarChartComponent';

const EquipmentRoomLive = () => {
    const { auth } = useSelector((state) => ({
        auth: state.Auth,
    }));
    const userRole = auth?.user?.role;

    const [data, setData] = useState([]);
    const [limit, setLimit] = useState(5);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    const [totalCount, setTotalCount] = useState(0);

    const [selectedZones, setSelectedZones] = useState([
        {
            label: 'ALL',
            value: 'all',
        },
    ]);
    const [selectedDivisions, setSelectedDivisions] = useState([
        {
            label: 'ALL',
            value: 'all',
        },
    ]);
    const [selectedStation, setSelectedStation] = useState([
        {
            label: 'ALL',
            value: 'all',
        },
    ]);
    const [selectedViews, setSelectedViews] = useState({ value: 'table', label: 'Table' });

    const [stations, setStations] = useState([]);
    const [zones, setZones] = useState([]);
    const [divisions, setDivisions] = useState([]);

    const [statusMessage, setStatusMessage] = useState('');

    const [pieChart, setPieChart] = useState([]);
    const [barChart, setBarChart] = useState([]);

    useEffect(() => {
        const fetchStation = async () => {
            await getRequestData(auth.user.id);
        };

        fetchStation();
    }, []);

    useEffect(() => {
        if (stations && stations.length > 0) {
            getEquipmentRoomLiveData(limit, pageNumber);
        }
    }, [stations]);

    const { t } = useTranslation();

    const getEquipmentRoomLiveData = async (limits, pages) => {
        Loading();

        let limitNumber = limits ? limits : limit;
        let pagesNumber = pages ? pages : pageNumber;

        const zone = selectedZones.some((z) => z.value === 'all') ? [] : selectedZones.map((z) => z.value);
        const division = selectedDivisions.some((d) => d.value === 'all') ? [] : selectedDivisions.map((d) => d.value);

        let station = [];
        if (userRole === 'super admin') {
            station = selectedStation.some((s) => s.value === 'all') ? [] : selectedStation.map((s) => s.value);
        } else {
            if (selectedStation.length > 0 && !selectedStation.some((s) => s.value === 'all')) {
                station = selectedStation.map((s) => s.value);
            } else {
                station = stations.filter((s) => s.value !== 'all').map((s) => s.value);
            }
        }

        let request = {
            zone,
            division,
            station,
            page_number: pagesNumber,
            page_size: limitNumber,
        };

        let response = await getEquipmentRoomLive(request);

        if (response) {
            let srNo = pagesNumber * limitNumber - limitNumber + 1;
            let dataArray = [];

            // GRAPH VARIABLES
            let barArray = [];
            let openCount = 0;
            let closeCount = 0;

            response?.zone?.forEach((z) => {
                z.division?.forEach((d) => {
                    d.station?.forEach((s) => {
                        s.equipment_rooms?.forEach((room) => {
                            // TABLE DATA
                            dataArray.push({
                                srNo: srNo++,
                                zoneCode: z.zc || '',
                                divisionCode: d.dc || '',
                                stationCode: s.sc || '',
                                equipmentRoomType: room.room_type || '',
                                temperature: room.temperature || '',
                                humidity: room.humidity || '',
                                relayRoomOpening: room.door_status || '',
                            });

                            // BAR GRAPH (Temperature)
                            barArray.push({
                                name: s.sc + '-' + room.room_type,
                                total: room.temperature || 0,
                            });

                            // PIE GRAPH (Door Status)
                            if (room.door_status === 'Open') openCount++;
                            else closeCount++;
                        });
                    });
                });
            });

            // FINAL PIE DATA
            const pieArray = [
                { name: 'Open', value: openCount },
                { name: 'Close', value: closeCount },
            ];

            // SET STATES
            setPieChart(pieArray);
            setBarChart(barArray);

            setData(dataArray);
            setPageNumber(response?.pagination?.currentPage);
            setPageCount(response?.pagination?.totalPages);
            setTotalCount(response?.pagination?.totalCount);

            setStatusMessage('Equipment Room Live details fetched successfully');
        }

        Loading();
    };

    const getRequestData = async (id) => {
        try {
            Loading(true);

            const response = await getUserRequestAPI(id);
            // console.log(response, 'getUserRequestAPI response....');

            if (response) {
                const { stations, zones, divisions } = mapRequestDataToOptions(response);

                // Component state me directly set
                setStations(stations);
                setZones(zones);
                setDivisions(divisions);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            Loading(false);
        }
    };

    //pagination
    const handlePageChange = async (value) => {
        setPageNumber(1);
        setLimit(value);
        await getEquipmentRoomLiveData(value, 1);
    };

    const handlePageClick = async (value) => {
        setPageNumber(value);
        await getEquipmentRoomLiveData(limit, value);
    };

    const viewOptions = [
        { label: 'Table', value: 'table' },
        { label: 'Pictorial', value: 'pictorial' },
    ];

    const handleSelectView = async (e) => {
        if (e?.value === 'table') {
            await getEquipmentRoomLiveData(5, 1);
        } else {
            await getEquipmentRoomLiveData(0, 0);
        }
        setSelectedViews(e);
    };

    return (
        <>
            <ToastContainer />
            <div className=" py-1 " style={{ width: '100%' }}>
                <div className="container-fluid px-0">
                    <div className="row align-items-center gx-2 gy-2">
                        {/* Alerts Overview Button */}
                        <div className="col-12 col-md-auto">
                            <button className="btn_1 w-100" style={{ marginLeft: '0' }}>
                                Equipment Room Live
                            </button>
                        </div>
                    </div>
                </div>

                {/* <div
                    className="report-alert-card my-2 p-1"
                    style={{
                        width: '100%',
                        boxShadow: ' 0px 0px 35px 0px rgba(154, 161, 171, 0.15)',
                        position: 'relative',
                        height: 'auto',
                    }}>
                    <div className="container form-container justify-content-center">
                        <form>
                            <div className="row d-flex flex-center">
                                <MultiSelectDropdown
                                    label="Zones"
                                    id="zoneSelect"
                                    options={zones}
                                    selectedValues={selectedZones}
                                    onChange={setSelectedZones}
                                />

                                <MultiSelectDropdown
                                    label="Divisions"
                                    id="divisionSelect"
                                    options={divisions}
                                    selectedValues={selectedDivisions}
                                    onChange={setSelectedDivisions}
                                />

                                <MultiSelectDropdown
                                    label="Station"
                                    id="stationSelect"
                                    options={stations}
                                    selectedValues={selectedStation}
                                    onChange={setSelectedStation}
                                />

                                <MultiSelectDropdown
                                    label="View"
                                    id="viewSelect"
                                    options={viewOptions}
                                    selectedValues={selectedViews}
                                    onChange={(e) => {
                                        handleSelectView(e);
                                    }}
                                    isMulti={false}
                                />
                            </div>

                            <div className="row mt-2">
                                <div className="col-md-12 text-end">
                                    <button
                                        type="button"
                                        className="btn "
                                        onClick={() => getEquipmentRoomLiveData(5, 1)}
                                        style={{
                                            backgroundColor: '#F9B74C',
                                            color: 'black',
                                            fontWeight: 'bold',
                                            width: '150px',
                                            textTransform: 'uppercase',
                                            fontFamily: "'Poppins', sans-serif",
                                            fontSize: '14px',
                                        }}>
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div> */}

                <div
                    className="report-alert-card my-2 p-1"
                    style={{
                        width: '100%',
                        boxShadow: '0px 0px 35px 0px rgba(154, 161, 171, 0.15)',
                        position: 'relative',
                        height: 'auto',
                    }}>
                    {/* sirf container aur spacing update */}
                    <div
                        className="container-fluid"
                        style={{
                            paddingLeft: '10px',
                            paddingRight: '10px',
                        }}>
                        <form>
                            <div className="row d-flex gx-3 gy-2">
                                <MultiSelectDropdown
                                    label="Zones"
                                    id="zoneSelect"
                                    options={zones}
                                    selectedValues={selectedZones}
                                    onChange={setSelectedZones}
                                />

                                <MultiSelectDropdown
                                    label="Divisions"
                                    id="divisionSelect"
                                    options={divisions}
                                    selectedValues={selectedDivisions}
                                    onChange={setSelectedDivisions}
                                />

                                <MultiSelectDropdown
                                    label="Station"
                                    id="stationSelect"
                                    options={stations}
                                    selectedValues={selectedStation}
                                    onChange={setSelectedStation}
                                />

                                <MultiSelectDropdown
                                    label="View"
                                    id="viewSelect"
                                    options={viewOptions}
                                    selectedValues={selectedViews}
                                    onChange={(e) => {
                                        handleSelectView(e);
                                    }}
                                    isMulti={false}
                                />
                            </div>

                            <div className="row mt-2">
                                <div className="col-md-12 text-end">
                                    <button
                                        type="button"
                                        className="btn"
                                        onClick={() => getEquipmentRoomLiveData(5, 1)}
                                        style={{
                                            backgroundColor: '#F9B74C',
                                            color: 'black',
                                            fontWeight: 'bold',
                                            width: '150px',
                                            textTransform: 'uppercase',
                                            fontFamily: "'Poppins', sans-serif",
                                            fontSize: '14px',
                                        }}>
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                {/* TABLE */}
                {(!selectedViews || selectedViews?.value === 'table') && data?.length > 0 && (
                    <div className="col-sm-12 card-alerts my-2 p-2 border-0 text-start no-radius">
                        <Table
                            columns={equipmentRoomLiveColumns}
                            data={data}
                            pageSize={limit}
                            pageCount={pageCount}
                            pageNumber={pageNumber}
                            totalCount={totalCount}
                            sizePerPageList={sizePerPageList}
                            isSortable={true}
                            pagination={true}
                            isSearchable={true}
                            onPageChange={handlePageChange}
                            onPageClick={handlePageClick}
                        />
                    </div>
                )}

                {selectedViews?.value === 'pictorial' && pieChart?.length > 0 && (
                    <div
                        className="col-sm-12 card-alerts my-2 p-2 border-0 text-start no-radius"
                        style={{ width: '100%', position: 'relative' }}>
                        <PieChartComponent data={pieChart || []} />
                    </div>
                )}

                {selectedViews?.value === 'pictorial' && barChart?.length > 0 && (
                    <div
                        className="col-sm-12 card-alerts my-2 p-2 border-0 text-start no-radius"
                        style={{ width: '100%', position: 'relative' }}>
                        <BarChartComponent data={barChart || []} />
                    </div>
                )}
            </div>

            <div className="modal fade" id="statusModal" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button
                                type="button"
                                className="btn-close ms-auto"
                                data-bs-dismiss="modal"
                                aria-label="Close"></button>
                        </div>
                        <div className="modal-body text-center">
                            <img
                                src="/asset-images/checkmark.png"
                                alt="Success"
                                className="img-fluid"
                                style={{ maxWidth: '100px' }}
                            />
                            <p className="mt-2">{statusMessage}</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default EquipmentRoomLive;
